module.exports = __webpack_public_path__ + "static/fonts/NotoSansCJKkr-Black.cc3462f.ttf";